export default {
  "Loop as a GIF": "Loop as a GIF",
  "without sound": "without sound",
  "Final output duration": "Final output duration",
};
